<template>
  <v-row no-gutters>
    <p class="text-left font-weight-bold body-2 grey--text text--darken-2 mb-0">Opções de entrega</p>

    <v-col lg="12">
      <!-- <v-checkbox
        v-model="selecaoEntrega"
        v-for="(entrega, i) in opcoesEntrega"
        :key="i"
        :label="entrega.label"
        :value="entrega.key"
        @click="selecionarOpcaoEntrega()"
        hide-details="true"
        color="var(--vs-azul-primaria)"
        class="mt-0"
      ></v-checkbox>-->

      <!-- <v-select
        v-model="selecaoEntrega"
        :items="opcoesEntrega"
        item-text="label"
        class="mt-0"
        color="var(--vs-azul-primaria)"
        return-object
        @change="selecionarOpcaoEntrega()"
        style="width:60%"
      ></v-select>-->

      <v-radio-group v-model="selecaoEntrega" row @change="selecionarOpcaoEntrega()" >
        <v-radio label="Frete" value="FRT" color="var(--vs-azul-primaria)"></v-radio>
        <v-radio label="Retirada na loja" value="BAL" color="var(--vs-azul-primaria)"></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: [""],
  data() {
    return {
      opcoesEntrega: [
        {
          key: "FRT",
          label: "Frete",
        },
        // {
        //   key: "FOB",
        //   label: "FOB",
        // },
        {
          key: "BAL",
          label: "Retirada na loja",
        },
      ],
      selecaoEntrega: '',
    };
  },
  methods: {
    selecionarOpcaoEntrega() {
      if (this.selecaoEntrega === "BAL") {
        this.$store.commit("pedido/setValorFrete", false);
        this.$store.dispatch("pedido/totalPedidoSemFrete");
        this.$store.dispatch("pedido/totalPedidoComFrete");
      }
      this.$store.commit("pedido/setValorFrete", true);
      this.$store.dispatch("pedido/tipoEntrega", this.selecaoEntrega);
    },
  },
  computed: {
    ...mapGetters({
      tipoEntrega: "pedido/tipoEntrega",
    }),
  },
  mounted() {
    if(this.tipoEntrega === null || this.tipoEntrega === "") {
      this.$store.dispatch("pedido/tipoEntrega", 'BAL');
    }
    this.selecaoEntrega = this.tipoEntrega;
  },
};
</script>

<style scoped>
</style>
